/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ChatControllerGetRequestStatusQueryResponse, ChatControllerGetRequestStatusPathParams, ChatControllerGetRequestStatus401, ChatControllerGetRequestStatus403, ChatControllerGetRequestStatus404 } from "../../models/chatController/ChatControllerGetRequestStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { chatControllerGetRequestStatus } from "../../clients/chatService/chatControllerGetRequestStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const chatControllerGetRequestStatusQueryKey = (requestId: ChatControllerGetRequestStatusPathParams["requestId"]) => [{
  url: '/api/v1/chat/status/:requestId',
  params: {
    requestId: requestId
  }
}] as const;
export type ChatControllerGetRequestStatusQueryKey = ReturnType<typeof chatControllerGetRequestStatusQueryKey>;
export function chatControllerGetRequestStatusQueryOptions(requestId: ChatControllerGetRequestStatusPathParams["requestId"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = chatControllerGetRequestStatusQueryKey(requestId);
  return queryOptions<ChatControllerGetRequestStatusQueryResponse, ResponseErrorConfig<ChatControllerGetRequestStatus401 | ChatControllerGetRequestStatus403 | ChatControllerGetRequestStatus404>, ChatControllerGetRequestStatusQueryResponse, typeof queryKey>({
    enabled: !!requestId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return chatControllerGetRequestStatus(requestId, config);
    }
  });
}

/**
 * @summary Get status of a chat request
 * {@link /api/v1/chat/status/:requestId}
 */
export function useChatControllerGetRequestStatus<TData = ChatControllerGetRequestStatusQueryResponse, TQueryData = ChatControllerGetRequestStatusQueryResponse, TQueryKey extends QueryKey = ChatControllerGetRequestStatusQueryKey>(requestId: ChatControllerGetRequestStatusPathParams["requestId"], options: {
  query?: Partial<QueryObserverOptions<ChatControllerGetRequestStatusQueryResponse, ResponseErrorConfig<ChatControllerGetRequestStatus401 | ChatControllerGetRequestStatus403 | ChatControllerGetRequestStatus404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? chatControllerGetRequestStatusQueryKey(requestId);
  const query = useQuery({
    ...chatControllerGetRequestStatusQueryOptions(requestId, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ChatControllerGetRequestStatus401 | ChatControllerGetRequestStatus403 | ChatControllerGetRequestStatus404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}